
import { Link } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";

export const NavbarLogo = () => {
  const isMobile = useIsMobile();
  
  return (
    <div className="flex-shrink-0 flex items-center">
      <Link to="/" className="flex items-center">
        <img
          src={isMobile 
            ? "https://dynamico.cloud/assets/img/logos/miniLogo.svg"
            : "https://dynamico.cloud/assets/img/logos/logoAlt.svg"
          }
          alt="Dynamico Logo"
          className="h-10 md:h-12"
        />
      </Link>
    </div>
  );
};
